
export const delIcon = {
    position: 'absolute',
    right: '1%',
    top: '7%',
}